export type ModalStyle = 'confirmation' | 'check' | 'default' | 'error' | 'warning'

export const CONFIRMATION_STYLE: ModalStyle = 'confirmation'
export const CHECK_STYLE: ModalStyle = 'check'
export const DEFAULT_STYLE: ModalStyle = 'default'
export const ERROR_STYLE: ModalStyle = 'error'
export const WARNING_STYLE: ModalStyle = 'warning'
